"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const TabularConfiguration_1 = require("../models/TabularConfiguration");
const FarmsAnalyticsService_1 = __importDefault(require("../services/FarmsAnalyticsService"));
const trans_1 = require("@common/tsutils/trans");
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
class TabularAnalyticsController {
    constructor() {
        this.farms = [];
        this.service = new FarmsAnalyticsService_1.default();
        //this.displayMode = 'default';
        this.configuration = new TabularConfiguration_1.TabularConfiguration();
        this.searchCriteria = '';
        this.selectedFarm = null;
        this.loadingFarms = false;
        this.loadingAllPagesFarms = false;
        this.configuration.categoryHasMetric = this.categoryHasMetric.bind(this);
        this.farmsTableRef = null;
        this.fieldsTableRef = null;
        this.tabularMode = 'farms';
    }
    isNodeActive(labelToFind) {
        const checkNode = (nodes) => {
            for (const node of nodes) {
                if (node.label === labelToFind && node.checked) {
                    return true;
                }
                if (node.children && checkNode(node.children)) {
                    return true;
                }
            }
            return false;
        };
        return checkNode(this.configuration.columnManager.tree);
    }
    needsHasNode() {
        return this.farms.some(farm => farm.breakdownNeeds.some(metric => this.isNodeActive(metric.name)));
    }
    recHasNode() {
        return this.farms.some(farm => farm.breakdownRecommendations.some(metric => this.isNodeActive(metric.name)));
    }
    categoryHasMetricNode(categoryName) {
        return this.farms.some(farm => farm.breakdownMetrics.some(group => group.name === categoryName &&
            group.metrics.some(metric => this.isNodeActive(metric.name))));
    }
    categoryHasMetric(categoryName, metricName) {
        return this.farms.some(farm => farm.breakdownMetrics.some(group => group.name === categoryName &&
            group.metrics.some(metric => metric.name === metricName)));
    }
    /*     setDisplayMode(newMode:string){
            if(this.displayMode === newMode) this.displayMode = 'default'
            this.displayMode = newMode;
        } */
    createAcreageModel(value, unit) {
        return new Acreage_1.default(value, unit, true);
    }
    switchExtensionUnits(unit) {
        const switchFn = unit === 'ha' ? 'switchToHectareas' : 'switchToAcres';
        const applySwitchToRanks = (ranks) => {
            Object.values(ranks).forEach((rank) => {
                var _a, _b;
                (_b = (_a = rank.acreageByFarm) === null || _a === void 0 ? void 0 : _a[switchFn]) === null || _b === void 0 ? void 0 : _b.call(_a);
            });
        };
        this.farms.forEach((farm) => {
            var _a, _b;
            // 🟢 Nivel Farm
            (_b = (_a = farm.acreageByFarm) === null || _a === void 0 ? void 0 : _a[switchFn]) === null || _b === void 0 ? void 0 : _b.call(_a);
            farm.breakdownRecommendations.forEach((recom) => {
                recom.type.forEach((type) => {
                    var _a;
                    const acreage = this.createAcreageModel(type.value, type.unit);
                    (_a = acreage === null || acreage === void 0 ? void 0 : acreage[switchFn]) === null || _a === void 0 ? void 0 : _a.call(acreage);
                });
            });
            farm.breakdownNeeds.forEach((need) => {
                applySwitchToRanks(need.ranks);
            });
            farm.breakdownMetrics.forEach((metric) => {
                metric.metrics.forEach((m) => {
                    applySwitchToRanks(m.ranks);
                });
            });
            // 🟡 Nivel Field
            farm.fieldsAnalytics.forEach((field) => {
                var _a, _b, _c, _d, _e;
                (_b = (_a = field.acreage) === null || _a === void 0 ? void 0 : _a[switchFn]) === null || _b === void 0 ? void 0 : _b.call(_a);
                (_c = field.breakdownRecommendations) === null || _c === void 0 ? void 0 : _c.forEach((recom) => {
                    recom.type.forEach((type) => {
                        var _a;
                        const acreage = this.createAcreageModel(type.value, type.unit);
                        (_a = acreage === null || acreage === void 0 ? void 0 : acreage[switchFn]) === null || _a === void 0 ? void 0 : _a.call(acreage);
                    });
                });
                (_d = field.breakdownNeeds) === null || _d === void 0 ? void 0 : _d.forEach((need) => {
                    applySwitchToRanks(need.ranks);
                });
                (_e = field.breakdownMetrics) === null || _e === void 0 ? void 0 : _e.forEach((metric) => {
                    metric.metrics.forEach((m) => {
                        applySwitchToRanks(m.ranks);
                    });
                });
            });
        });
    }
    updatedSelectFarm(newFarm) {
        this.selectedFarm = newFarm;
    }
    get farmsFilter() {
        return this.farms.filter((farm) => {
            return farm.name.toLowerCase().trim().includes(this.searchCriteria.toLowerCase().trim());
        });
    }
    fieldsFilter(selectedFarmId) {
        const farm = this.farms.find(farm => farm.id === selectedFarmId);
        if (farm) {
            return farm.fieldsAnalytics.filter((field) => {
                return field.name.toLowerCase().trim().includes(this.searchCriteria.toLowerCase().trim());
            });
        }
        else {
            return [];
        }
    }
    updatedSearchCriteria(newValue) {
        this.searchCriteria = newValue;
    }
    static getInstance() {
        if (this._instance)
            return this._instance;
        this._instance = new TabularAnalyticsController();
        return this._instance;
    }
    async getFarmAnalytics() {
        try {
            const pageSize = 30;
            this.farms = [];
            this.loadingFarms = true;
            this.loadingAllPagesFarms = true;
            const firstPageFarms = await this.service.getFarms(1);
            this.farms.push(...firstPageFarms);
            const totalFarms = this.service.totalElements || 0;
            const totalPages = Math.ceil(totalFarms / pageSize);
            this.switchExtensionUnits('ha');
            this.loadingFarms = false;
            for (let page = 2; page <= totalPages; page++) {
                const farms = await this.service.getFarms(page);
                this.configuration.recommendations = this.getAllUniqueRecommendations;
                this.configuration.needs = this.getAllUniqueNeeds;
                this.configuration.metrics = this.getUniqueMetricNames;
                this.configuration.categories = this.getAllUniqueCategoriesNames;
                this.configuration.phch = this.getUniquePhchNames.map(obj => obj.name);
                this.farms.push(...farms);
            }
            this.configuration.recommendations = this.getAllUniqueRecommendations;
            this.configuration.needs = this.getAllUniqueNeeds;
            this.configuration.metrics = this.getUniqueMetricNames;
            this.configuration.categories = this.getAllUniqueCategoriesNames;
            this.configuration.phch = this.getUniquePhchNames.map(obj => obj.name + ` (${obj.unit}) `);
            this.configuration.categoryHasMetric = this.categoryHasMetric;
            this.loadingAllPagesFarms = false;
            return this.farms;
        }
        catch (error) {
            console.error("Error fetching farm analytics:", error);
            throw error;
        }
    }
    get filterableColumns() {
        return this.configuration.columnManager.tree;
    }
    get baseColumns() {
        const keys = ['name', 'date', 'client', 'crop', 'acreage'];
        return keys.map((k) => {
            return {
                id: k,
                label: (0, trans_1.trans)(`tabular.configuration.basic.${k}`)
            };
        });
    }
    get getUniquePhchNames() {
        const uniqueSet = new Set();
        const result = [];
        for (const farm of this.farms) {
            for (const item of farm.breakdownPHCH || []) {
                const key = `${item.name}__${item.unit}`;
                if (!uniqueSet.has(key)) {
                    uniqueSet.add(key);
                    result.push({ name: item.name, unit: item.unit });
                }
            }
        }
        return result;
    }
    get getAllUniqueRecommendations() {
        const recommendationsSet = new Set();
        this.farms.forEach(farm => {
            farm.breakdownRecommendations.forEach(rec => {
                recommendationsSet.add(rec.name);
            });
        });
        return Array.from(recommendationsSet);
    }
    get getAllUniqueNeeds() {
        const recommendationsSet = new Set();
        this.farms.forEach(farm => {
            farm.breakdownNeeds.forEach(rec => {
                recommendationsSet.add(rec.name);
            });
        });
        return Array.from(recommendationsSet);
    }
    get getAllUniqueCategoriesNames() {
        const categories = new Set();
        this.farms.forEach(farm => {
            farm.breakdownMetrics.forEach(group => {
                // ¿Alguna métrica de este grupo está activa?
                const hasActiveMetric = group.metrics;
                if (hasActiveMetric) {
                    categories.add(group.name);
                }
            });
        });
        return Array.from(categories);
    }
    /**
  * Devuelve la lista de categorías únicas (group.name) de todas las farms,
  * pero sólo aquellas categorías en las que al menos una métrica está activa.
  */
    get getAllUniqueCategories() {
        const categories = new Set();
        this.farms.forEach(farm => {
            farm.breakdownMetrics.forEach(group => {
                // ¿Alguna métrica de este grupo está activa?
                const hasActiveMetric = group.metrics.some(m => this.isNodeActive(m.name));
                if (hasActiveMetric) {
                    categories.add(group.name);
                }
            });
        });
        return Array.from(categories);
    }
    isDiseasesMetric(metricName, farmId) {
        const farms = farmId ? [this.getFarmById(farmId)] : this.getAllFarms();
        for (const farm of farms) {
            if (!farm || !farm.breakdownMetrics)
                continue;
            const validNames = ['Diseases', 'Enfermedades', 'Maladies'];
            const categoryItem = farm.breakdownMetrics.find(category => validNames.includes(category.name));
            if (categoryItem && categoryItem.metrics.some(metric => metric.name === metricName)) {
                return true;
            }
        }
        return false;
    }
    /**
     * Devuelve la lista de nombres de métricas para la categoría dada,
     * recorriendo todas las farms y eliminando duplicados, luego filtra
     * solo las métricas activas.
     */
    getMetricsByCategory(category) {
        const metricsSet = new Set();
        this.farms.forEach(farm => {
            farm.breakdownMetrics.forEach(group => {
                if (group.name === category) {
                    group.metrics.forEach(m => {
                        if (this.isNodeActive(m.name)) {
                            metricsSet.add(m.name);
                        }
                    });
                }
            });
        });
        return Array.from(metricsSet);
    }
    getAllUniqueCategoriesID(farmId) {
        const farm = this.getFarmById(farmId);
        if (!farm)
            return [];
        return farm.breakdownMetrics
            .map(group => group.name)
            .filter((category, idx, arr) => {
            var _a, _b;
            // eliminamos duplicados
            if (arr.indexOf(category) !== idx)
                return false;
            // comprobamos si en esa categoría hay alguna métrica activa
            const metrics = (_b = (_a = farm.breakdownMetrics.find(g => g.name === category)) === null || _a === void 0 ? void 0 : _a.metrics) !== null && _b !== void 0 ? _b : [];
            return metrics.some(m => this.isNodeActive(m.name));
        });
    }
    /**
     * Devuelve la lista de métricas activas de una categoría concreta
     * para la granja indicada.
     */
    getMetricsByCategoryID(farmId, category) {
        const farm = this.getFarmById(farmId);
        if (!farm)
            return [];
        const group = farm.breakdownMetrics.find(g => g.name === category);
        if (!group)
            return [];
        return group.metrics
            .map(m => m.name)
            .filter(name => this.isNodeActive(name));
    }
    get getUniqueMetricNames() {
        const metricNameSet = new Set();
        const names = new Set();
        this.farms.forEach(farm => {
            farm.breakdownMetrics.forEach((category) => {
                category.metrics.forEach((metric) => {
                    names.add(metric.name);
                });
            });
        });
        return Array.from(names);
    }
    getMetricByName(metricName) {
        for (const farm of this.farms) {
            for (const category of farm.breakdownMetrics) {
                const found = category.metrics.find(m => m.name === metricName);
                if (found) {
                    return found;
                }
            }
        }
        return undefined;
    }
    getRecommendationByName(recommendationName) {
        for (const farm of this.farms) {
            const found = farm.breakdownRecommendations.find(r => r.name === recommendationName);
            if (found) {
                return found;
            }
        }
        return undefined;
    }
    getAllMetricsFromFarm(farmId) {
        const farm = this.farms.find(f => f.id === farmId);
        if (!farm) {
            console.warn(`Farm with ID ${farmId} not found.`);
            return [];
        }
        const metrics = [];
        farm.breakdownMetrics.forEach((category) => {
            category.metrics.forEach((metric) => {
                metrics.push(metric);
            });
        });
        return metrics;
    }
    getAllMetricsFromFields(farmId, fieldId) {
        const farm = this.farms.find(f => f.id === farmId);
        if (farm) {
            const field = farm.fieldsAnalytics.find(f => f.id === fieldId);
            const metrics = [];
            if (field) {
                field.breakdownMetrics.forEach((category) => {
                    category.metrics.forEach((metric) => {
                        metrics.push(metric);
                    });
                });
                return metrics;
            }
        }
    }
    getUniqueClientCodeCount() {
        const uniqueCodes = new Set(this.farms.map(farm => farm.client_code));
        return uniqueCodes.size;
    }
    addFarms(newFarm) {
        this.farms.push(newFarm);
    }
    getAllFarms() {
        return this.farms;
    }
    getFarmById(farmId) {
        return this.farms.find(f => f.id === farmId);
    }
    searchFarmsByName(keyword) {
        const lowerKeyword = keyword.toLowerCase();
        return this.farms.filter(farm => farm.name.toLowerCase().includes(lowerKeyword));
    }
    sortFarmsById(descending = false) {
        this.farms.sort((a, b) => {
            if (a.id < b.id)
                return descending ? 1 : -1;
            if (a.id > b.id)
                return descending ? -1 : 1;
            return 0;
        });
    }
    sortFarmsByName(descending = false) {
        this.farms.sort((a, b) => {
            const nameA = a.name.toLowerCase();
            const nameB = b.name.toLowerCase();
            if (nameA < nameB)
                return descending ? 1 : -1;
            if (nameA > nameB)
                return descending ? -1 : 1;
            return 0;
        });
    }
    sortFarmsByMetricCount(descending = true) {
        this.farms.sort((a, b) => {
            const countA = a.breakdownMetrics.length;
            const countB = b.breakdownMetrics.length;
            return descending ? countB - countA : countA - countB;
        });
    }
    removeFarmById(farmId) {
        const index = this.farms.findIndex(f => f.id === farmId);
        if (index !== -1) {
            this.farms.splice(index, 1);
            return true;
        }
        return false;
    }
    updateFarm(farmId, updatedFarm) {
        const index = this.farms.findIndex(f => f.id === farmId);
        if (index !== -1) {
            this.farms[index] = updatedFarm;
            return true;
        }
        return false;
    }
    filterFarmsByRecommendation(recommendationName) {
        return this.farms.filter(farm => farm.breakdownRecommendations.some(r => r.name === recommendationName));
    }
    filterFarmsByMetric(MetricName) {
        return this.farms.filter(farm => farm.breakdownMetrics.some(r => r.name === MetricName));
    }
    filterFarmsByNeed(needName) {
        return this.farms.filter(farm => farm.breakdownNeeds.some(r => r.name === needName));
    }
    clearFarms() {
        this.farms = [];
    }
    getAllUniqueCategoriesObject() {
        const categories = new Set();
        this.farms.forEach(farm => {
            farm.breakdownMetrics.forEach(group => {
                categories.add(group);
            });
        });
        return Array.from(categories);
    }
    getCategorieByMetric(metricName) {
        const categorie = this.getAllUniqueCategoriesObject().find(categorie => categorie.metrics.some(metric => metric.name === metricName));
        return categorie ? categorie.name : '---';
    }
    exportFarmCSVById(farmId) {
        var _a;
        const headers = [(0, trans_1.trans)('tabular.configuration.basic.name'), (0, trans_1.trans)('tabular.configuration.basic.crop'), (0, trans_1.trans)('tabular.configuration.basic.acreage')];
        const rows = [];
        const activeRecs = this.configuration.isPresetActive('recommendations')
            ? this.getAllUniqueRecommendations.filter(r => this.isNodeActive(r))
            : [];
        const activeNeeds = this.configuration.isPresetActive('needs')
            ? this.getAllUniqueNeeds.filter(n => this.isNodeActive(n))
            : [];
        const activePhch = this.configuration.isPresetActive('phch_metrics')
            ? this.getUniquePhchNames.filter(n => this.isNodeActive(n.name + ` (${n.unit}) `))
            : [];
        const activeMetrics = this.configuration.isPresetActive('metrics')
            ? this.getUniqueMetricNames.filter(m => this.isNodeActive(m))
            : [];
        const mode = this.configuration.mode;
        // Agrega encabezados dinámicos
        activeRecs.forEach(rec => headers.push(`${rec}`));
        activePhch.forEach(need => {
            headers.push(`${need.name.replace(/,/g, " ")} (${need.unit.replace(/,/g, " ")})`);
        });
        activeNeeds.forEach(need => {
            if (mode === 'rank_distribution') {
                ['veryLow', 'low', 'medium', 'high', 'veryHigh'].forEach(level => {
                    headers.push(`${need} - ${level}`);
                });
            }
            else {
                headers.push(`${need}`);
            }
        });
        activeMetrics.forEach(metric => {
            if (mode === 'rank_distribution') {
                ['veryLow', 'low', 'medium', 'high', 'veryHigh'].forEach(level => {
                    headers.push(`${metric} (${this.getCategorieByMetric(metric)}) - ${level}`);
                });
            }
            else {
                headers.push(`${metric} (${this.getCategorieByMetric(metric)})`);
            }
        });
        const fieldsDefault = (_a = this.farms.find((farm) => farm.id === farmId)) === null || _a === void 0 ? void 0 : _a.fieldsAnalytics;
        const currentFarm = this.farms.find((farm) => farm.id === farmId);
        // Construir filas
        console.log(this.searchCriteria, this.fieldsFilter(farmId), fieldsDefault);
        const fields = this.searchCriteria ? this.fieldsFilter(farmId) : fieldsDefault;
        fields.forEach(field => {
            var _a, _b;
            const row = [
                field.name.replace(/,/g, ''),
                field.cropsAnalytics.length > 1 ? 'Multicrop' : field.cropsAnalytics[0].name,
                (_b = (_a = field.acreage) === null || _a === void 0 ? void 0 : _a.shortLabel) !== null && _b !== void 0 ? _b : ''
            ];
            // Recomendaciones
            activeRecs.forEach(rec => {
                const match = field.breakdownRecommendations.find(r => r.name === rec);
                if (mode === 'rank_distribution') {
                    if (match === null || match === void 0 ? void 0 : match.type) {
                        const parts = ['NUT', 'SHI', 'HLT'].map(code => {
                            var _a;
                            const item = (_a = match.type) === null || _a === void 0 ? void 0 : _a.find(t => t.code === code);
                            return item ? `${this.createAcreage(item.value, item.unit)}` : null;
                        }).filter(Boolean);
                        row.push(parts.length > 0 ? parts.join(' | ') : '---');
                    }
                    else {
                        row.push('---');
                    }
                }
                else {
                    if (match === null || match === void 0 ? void 0 : match.type) {
                        const codeMap = {
                            NUT: 'NUT',
                            HLT: 'HEA',
                            SHI: 'SUS'
                        };
                        const parts = ['NUT', 'SHI', 'HLT'].map(code => {
                            var _a;
                            const item = (_a = match.type) === null || _a === void 0 ? void 0 : _a.find(t => t.code === code);
                            return item ? codeMap[code] : null;
                        }).filter(Boolean);
                        row.push(parts.length > 0 ? parts.join(' | ') : '---');
                    }
                    else {
                        row.push('---');
                    }
                }
            });
            // Necesidades
            activeNeeds.forEach(need => {
                var _a;
                const match = field.breakdownNeeds.find(r => r.name === need);
                if (mode === 'rank_distribution') {
                    ['veryLow', 'low', 'medium', 'high', 'veryHigh'].forEach(level => {
                        var _a, _b, _c, _d;
                        row.push((_d = (_c = (_b = (_a = match === null || match === void 0 ? void 0 : match.ranks) === null || _a === void 0 ? void 0 : _a[level]) === null || _b === void 0 ? void 0 : _b.acreageByFarm) === null || _c === void 0 ? void 0 : _c.shortLabel) !== null && _d !== void 0 ? _d : '---');
                    });
                }
                else {
                    row.push((_a = match === null || match === void 0 ? void 0 : match.valueByFarm) !== null && _a !== void 0 ? _a : '---');
                }
            });
            // Métricas
            activeMetrics.forEach(metric => {
                var _a;
                const metrics = this.getAllMetricsFromFields(currentFarm.id, field.id);
                const match = metrics.find(m => m.name === metric);
                if (mode === 'rank_distribution') {
                    ['veryLow', 'low', 'medium', 'high', 'veryHigh'].forEach(level => {
                        var _a, _b, _c, _d;
                        row.push((_d = (_c = (_b = (_a = match === null || match === void 0 ? void 0 : match.ranks) === null || _a === void 0 ? void 0 : _a[level]) === null || _b === void 0 ? void 0 : _b.acreageByFarm) === null || _c === void 0 ? void 0 : _c.shortLabel) !== null && _d !== void 0 ? _d : '---');
                    });
                }
                else {
                    row.push((_a = match === null || match === void 0 ? void 0 : match.valueByFarm.toFixed(0)) !== null && _a !== void 0 ? _a : '---');
                }
            });
            activePhch.forEach(need => {
                var _a;
                const match = field.breakdownPHCH.find(r => r.name === need.name && r.unit === need.unit);
                row.push((_a = match === null || match === void 0 ? void 0 : match.valueByFarm) !== null && _a !== void 0 ? _a : '---');
            });
            rows.push(row);
        });
        // Exportar como CSV
        const csvContent = [headers, ...rows].map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${currentFarm.name}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    createAcreage(value, unit) {
        return new Acreage_1.default(value, unit, true).shortLabel;
    }
    exportCSVManually() {
        const headers = [(0, trans_1.trans)('tabular.configuration.basic.name'), (0, trans_1.trans)('tabular.configuration.basic.date'), (0, trans_1.trans)('tabular.configuration.basic.client'), (0, trans_1.trans)('tabular.configuration.basic.crop'), (0, trans_1.trans)('tabular.configuration.basic.acreage')];
        const rows = [];
        const activeRecs = this.configuration.isPresetActive('recommendations')
            ? this.getAllUniqueRecommendations.filter(r => this.isNodeActive(r))
            : [];
        const activeNeeds = this.configuration.isPresetActive('needs')
            ? this.getAllUniqueNeeds.filter(n => this.isNodeActive(n))
            : [];
        const activePhch = this.configuration.isPresetActive('phch_metrics')
            ? this.getUniquePhchNames.filter(n => this.isNodeActive(n.name + ` (${n.unit}) `))
            : [];
        const activeMetrics = this.configuration.isPresetActive('metrics')
            ? this.getUniqueMetricNames.filter(m => this.isNodeActive(m))
            : [];
        const mode = this.configuration.mode;
        // Agrega encabezados dinámicos
        activeRecs.forEach(rec => headers.push(`${rec}`));
        activeNeeds.forEach(need => {
            if (mode === 'rank_distribution') {
                ['veryLow', 'low', 'medium', 'high', 'veryHigh'].forEach(level => {
                    headers.push(`${need} - ${level}`);
                });
            }
            else {
                headers.push(`${need}`);
            }
        });
        activePhch.forEach(need => {
            headers.push(`${need.name.replace(/,/g, " ")} (${need.unit.replace(/,/g, " ")})`);
        });
        activeMetrics.forEach(metric => {
            if (mode === 'rank_distribution') {
                ['veryLow', 'low', 'medium', 'high', 'veryHigh'].forEach(level => {
                    headers.push(`${metric} (${this.getCategorieByMetric(metric)}) - ${level}`);
                });
            }
            else {
                headers.push(`${metric} (${this.getCategorieByMetric(metric)})`);
            }
        });
        const farms = this.searchCriteria ? this.farmsFilter : this.farms;
        // Construir filas
        farms.forEach(farm => {
            var _a, _b;
            const row = [
                farm.name.replace(/,/g, ''),
                farm.created_at,
                farm.client_name.replace(/,/g, ''),
                farm.cropsAnalytics.length > 1 ? 'Multicrop' : farm.cropsAnalytics[0].name,
                (_b = (_a = farm.acreageByFarm) === null || _a === void 0 ? void 0 : _a.shortLabel) !== null && _b !== void 0 ? _b : ''
            ];
            // Recomendaciones
            activeRecs.forEach(rec => {
                const match = farm.breakdownRecommendations.find(r => r.name === rec);
                if (mode === 'rank_distribution') {
                    if (match === null || match === void 0 ? void 0 : match.type) {
                        const parts = ['NUT', 'SHI', 'HLT'].map(code => {
                            var _a;
                            const item = (_a = match.type) === null || _a === void 0 ? void 0 : _a.find(t => t.code === code);
                            return item ? `${this.createAcreage(item.value, item.unit)}` : null;
                        }).filter(Boolean);
                        row.push(parts.length > 0 ? parts.join(' | ') : '---');
                    }
                    else {
                        row.push('---');
                    }
                }
                else {
                    if (match === null || match === void 0 ? void 0 : match.type) {
                        const codeMap = {
                            NUT: 'NUT',
                            HLT: 'HEA',
                            SHI: 'SUS'
                        };
                        const parts = ['NUT', 'SHI', 'HLT'].map(code => {
                            var _a;
                            const item = (_a = match.type) === null || _a === void 0 ? void 0 : _a.find(t => t.code === code);
                            return item ? codeMap[code] : null;
                        }).filter(Boolean);
                        row.push(parts.length > 0 ? parts.join(' | ') : '---');
                    }
                    else {
                        row.push('---');
                    }
                }
            });
            // Necesidades
            activeNeeds.forEach(need => {
                var _a;
                const match = farm.breakdownNeeds.find(r => r.name === need);
                if (mode === 'rank_distribution') {
                    ['veryLow', 'low', 'medium', 'high', 'veryHigh'].forEach(level => {
                        var _a, _b, _c, _d;
                        row.push((_d = (_c = (_b = (_a = match === null || match === void 0 ? void 0 : match.ranks) === null || _a === void 0 ? void 0 : _a[level]) === null || _b === void 0 ? void 0 : _b.acreageByFarm) === null || _c === void 0 ? void 0 : _c.shortLabel) !== null && _d !== void 0 ? _d : '---');
                    });
                }
                else {
                    row.push((_a = match === null || match === void 0 ? void 0 : match.valueByFarm) !== null && _a !== void 0 ? _a : '---');
                }
            });
            // Métricas
            activeMetrics.forEach(metric => {
                var _a;
                const metrics = this.getAllMetricsFromFarm(farm.id);
                const match = metrics.find(m => m.name === metric);
                if (mode === 'rank_distribution') {
                    ['veryLow', 'low', 'medium', 'high', 'veryHigh'].forEach(level => {
                        var _a, _b, _c, _d;
                        row.push((_d = (_c = (_b = (_a = match === null || match === void 0 ? void 0 : match.ranks) === null || _a === void 0 ? void 0 : _a[level]) === null || _b === void 0 ? void 0 : _b.acreageByFarm) === null || _c === void 0 ? void 0 : _c.shortLabel) !== null && _d !== void 0 ? _d : '---');
                    });
                }
                else {
                    row.push((_a = match === null || match === void 0 ? void 0 : match.valueByFarm.toFixed(0)) !== null && _a !== void 0 ? _a : '---');
                }
            });
            activePhch.forEach(need => {
                var _a, _b;
                const match = (_a = farm.breakdownPHCH) === null || _a === void 0 ? void 0 : _a.find(r => r.name.trim().toLowerCase() === need.name.trim().toLowerCase() &&
                    r.unit.trim() === need.unit.trim());
                row.push((_b = match === null || match === void 0 ? void 0 : match.valueByFarm) !== null && _b !== void 0 ? _b : '---');
            });
            rows.push(row);
        });
        // Exportar como CSV
        const csvContent = [headers, ...rows].map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `farms_${this.farms[0].client_name}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    exportAllFarmsCSV() {
        const headers = [(0, trans_1.trans)('tabular.configuration.basic.name'), (0, trans_1.trans)('tabular.configuration.basic.date'), (0, trans_1.trans)('tabular.configuration.basic.client'), (0, trans_1.trans)('tabular.configuration.basic.crop'), (0, trans_1.trans)('tabular.configuration.basic.acreage')];
        const rows = [];
        const activeRecs = this.getAllUniqueRecommendations;
        const activeNeeds = this.getAllUniqueNeeds;
        const activePhch = this.getUniquePhchNames;
        const activeMetrics = this.getUniqueMetricNames;
        const rankLevels = ['veryLow', 'low', 'medium', 'high', 'veryHigh'];
        activeRecs.forEach(rec => {
            headers.push(`${rec} (score)`);
            headers.push(`${rec} (acreage)`);
        });
        activeNeeds.forEach(need => {
            headers.push(`${need} (score)`);
            rankLevels.forEach(level => headers.push(`${need} - ${level}`));
        });
        activeMetrics.forEach(metric => {
            headers.push(`${metric} (score)`);
            rankLevels.forEach(level => headers.push(`${metric} (${this.getCategorieByMetric(metric)}) - ${level}`));
        });
        activePhch.forEach(need => {
            headers.push(`${need.name.replace(/,/g, " ")} (${need.unit.replace(/,/g, " ")})`);
        });
        const farms = this.searchCriteria ? this.farmsFilter : this.farms;
        const mode = this.configuration.mode;
        farms.forEach(farm => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            const row = [
                (_a = farm.name.replace(/,/g, '')) !== null && _a !== void 0 ? _a : '---',
                (_b = farm.created_at) !== null && _b !== void 0 ? _b : '---',
                (_c = farm.client_name.replace(/,/g, '')) !== null && _c !== void 0 ? _c : '---',
                ((_d = farm.cropsAnalytics) === null || _d === void 0 ? void 0 : _d.length) > 1
                    ? 'Multicrop'
                    : ((_g = (_f = (_e = farm.cropsAnalytics) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : '---'),
                (_j = (_h = farm.acreageByFarm) === null || _h === void 0 ? void 0 : _h.shortLabel) !== null && _j !== void 0 ? _j : '---'
            ];
            activeRecs.forEach(rec => {
                const match = farm.breakdownRecommendations.find(r => r.name === rec);
                if (match && match.type.length > 0) {
                    const codeMap = {
                        NUT: 'NUT',
                        HLT: 'HEA',
                        SHI: 'SUS'
                    };
                    const parts1 = ['NUT', 'SHI', 'HLT'].map(code => {
                        const item = match.type.find(t => t.code === code);
                        return item ? codeMap[code] : null;
                    }).filter(Boolean);
                    const parts2 = ['NUT', 'SHI', 'HLT'].map(code => {
                        const item = match.type.find(t => t.code === code);
                        return item ? `${this.createAcreage(item.value, item.unit)}` : null;
                    }).filter(Boolean);
                    row.push(parts1.length > 0 ? parts1.join(' | ') : '---');
                    row.push(parts2.length > 0 ? parts2.join(' | ') : '---');
                }
                else {
                    row.push('---');
                    row.push('---');
                }
            });
            activeNeeds.forEach(need => {
                var _a;
                const match = farm.breakdownNeeds.find(r => r.name === need);
                if (match) {
                    row.push((_a = match.valueByFarm) !== null && _a !== void 0 ? _a : '---');
                    rankLevels.forEach(level => {
                        var _a, _b, _c, _d;
                        row.push((_d = (_c = (_b = (_a = match.ranks) === null || _a === void 0 ? void 0 : _a[level]) === null || _b === void 0 ? void 0 : _b.acreageByFarm) === null || _c === void 0 ? void 0 : _c.shortLabel) !== null && _d !== void 0 ? _d : '---');
                    });
                }
                else {
                    row.push('---');
                    rankLevels.forEach(() => row.push('---'));
                }
            });
            const metrics = (_k = this.getAllMetricsFromFarm(farm.id)) !== null && _k !== void 0 ? _k : [];
            activeMetrics.forEach(metric => {
                var _a;
                const match = metrics.find(m => m.name === metric);
                if (match) {
                    row.push((_a = match.valueByFarm.toFixed(0)) !== null && _a !== void 0 ? _a : '---');
                    rankLevels.forEach(level => {
                        var _a, _b, _c, _d;
                        row.push((_d = (_c = (_b = (_a = match.ranks) === null || _a === void 0 ? void 0 : _a[level]) === null || _b === void 0 ? void 0 : _b.acreageByFarm) === null || _c === void 0 ? void 0 : _c.shortLabel) !== null && _d !== void 0 ? _d : '---');
                    });
                }
                else {
                    row.push('---');
                    rankLevels.forEach(() => row.push('---'));
                }
            });
            activePhch.forEach(nd => {
                var _a;
                const match = farm.breakdownPHCH.find(r => r.name === nd.name && r.unit === nd.unit);
                row.push((_a = match === null || match === void 0 ? void 0 : match.valueByFarm) !== null && _a !== void 0 ? _a : '---');
            });
            rows.push(row);
        });
        const csvContent = [headers, ...rows].map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `farms_${this.farms[0].client_name}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    exportAllFieldsCSVByFarmId(farmId) {
        var _a;
        const farm = this.farms.find(f => f.id === farmId);
        if (!farm) {
            console.error("Farm not found");
            return;
        }
        const headers = [(0, trans_1.trans)('tabular.configuration.basic.name'), 'Field' + (0, trans_1.trans)('tabular.configuration.basic.name'), (0, trans_1.trans)('tabular.configuration.basic.date'), 'Client', (0, trans_1.trans)('tabular.configuration.basic.crop'), (0, trans_1.trans)('tabular.configuration.basic.acreage')];
        const rows = [];
        const activeRecs = this.getAllUniqueRecommendations;
        const activeNeeds = this.getAllUniqueNeeds;
        const activePhch = this.getUniquePhchNames;
        const activeMetrics = this.getUniqueMetricNames;
        const rankLevels = ['veryLow', 'low', 'medium', 'high', 'veryHigh'];
        // Agregar headers dinámicos
        activeRecs.forEach(rec => {
            headers.push(`${rec} (score)`);
            headers.push(`${rec} (acreage)`);
        });
        activeNeeds.forEach(need => {
            headers.push(`${need} (score)`);
            rankLevels.forEach(level => headers.push(`${need} - ${level}`));
        });
        activeMetrics.forEach(metric => {
            headers.push(`${metric} (score)`);
            rankLevels.forEach(level => headers.push(`${metric} (${this.getCategorieByMetric(metric)})  - ${level}`));
        });
        const fieldsDefault = (_a = this.farms.find((farm) => farm.id === farmId)) === null || _a === void 0 ? void 0 : _a.fieldsAnalytics;
        activePhch.forEach(need => {
            headers.push(`${need.name.replace(/,/g, " ")} (${need.unit.replace(/,/g, " ")})`);
        });
        // Construir filas
        const fields = this.searchCriteria ? this.fieldsFilter(farmId) : fieldsDefault;
        fields.forEach(field => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            const row = [
                (_a = farm.name.replace(/,/g, '')) !== null && _a !== void 0 ? _a : '---',
                (_b = field.name.replace(/,/g, '')) !== null && _b !== void 0 ? _b : '---',
                (_c = farm.created_at) !== null && _c !== void 0 ? _c : '---',
                (_d = farm.client_name) !== null && _d !== void 0 ? _d : '---',
                ((_e = field.cropsAnalytics) === null || _e === void 0 ? void 0 : _e.length) > 1
                    ? 'Multicrop'
                    : ((_h = (_g = (_f = farm.cropsAnalytics) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : '---'),
                (_k = (_j = field.acreage) === null || _j === void 0 ? void 0 : _j.shortLabel) !== null && _k !== void 0 ? _k : '---'
            ];
            // Recomendaciones
            activeRecs.forEach(rec => {
                const match = farm.breakdownRecommendations.find(r => r.name === rec);
                if (match && match.type.length > 0) {
                    const codeMap = {
                        NUT: 'NUT',
                        HLT: 'HEA',
                        SHI: 'SUS'
                    };
                    const parts1 = ['NUT', 'SHI', 'HLT'].map(code => {
                        const item = match.type.find(t => t.code === code);
                        return item ? codeMap[code] : null;
                    }).filter(Boolean);
                    const parts2 = ['NUT', 'SHI', 'HLT'].map(code => {
                        const item = match.type.find(t => t.code === code);
                        return item ? `${this.createAcreage(item.value, item.unit)}` : null;
                    }).filter(Boolean);
                    row.push(parts1.length > 0 ? parts1.join(' | ') : '---');
                    row.push(parts2.length > 0 ? parts2.join(' | ') : '---');
                }
                else {
                    row.push('---');
                    row.push('---');
                }
            });
            // Necesidades
            activeNeeds.forEach(need => {
                var _a, _b;
                const match = (_a = field.breakdownNeeds) === null || _a === void 0 ? void 0 : _a.find(n => n.name === need);
                row.push((_b = match === null || match === void 0 ? void 0 : match.valueByFarm) !== null && _b !== void 0 ? _b : '---');
                rankLevels.forEach(level => {
                    var _a, _b, _c, _d;
                    row.push((_d = (_c = (_b = (_a = match === null || match === void 0 ? void 0 : match.ranks) === null || _a === void 0 ? void 0 : _a[level]) === null || _b === void 0 ? void 0 : _b.acreage) === null || _c === void 0 ? void 0 : _c.shortLabel) !== null && _d !== void 0 ? _d : '---');
                });
            });
            // Métricas
            const metrics = (_m = (_l = farm.getAllMetricsFromField) === null || _l === void 0 ? void 0 : _l.call(farm, field.id)) !== null && _m !== void 0 ? _m : [];
            activeMetrics.forEach(metric => {
                var _a;
                const match = metrics.find(m => m.name === metric);
                row.push((_a = match === null || match === void 0 ? void 0 : match.valueByFarm) !== null && _a !== void 0 ? _a : '---');
                rankLevels.forEach(level => {
                    var _a, _b, _c, _d;
                    row.push((_d = (_c = (_b = (_a = match === null || match === void 0 ? void 0 : match.ranks) === null || _a === void 0 ? void 0 : _a[level]) === null || _b === void 0 ? void 0 : _b.acreage) === null || _c === void 0 ? void 0 : _c.shortLabel) !== null && _d !== void 0 ? _d : '---');
                });
            });
            activePhch.forEach(need => {
                var _a;
                const match = field.breakdownPHCH.find(r => r.name === need.name && r.unit === need.unit);
                row.push((_a = match === null || match === void 0 ? void 0 : match.valueByFarm.toFixed(0)) !== null && _a !== void 0 ? _a : '---');
            });
            rows.push(row);
        });
        // Exportar CSV
        const csvContent = [headers, ...rows].map(e => e.join(",")).join("\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `${farm.name}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}
exports.default = TabularAnalyticsController;
